import { render } from "./AdForm.vue?vue&type=template&id=2637e3cc"
import script from "./AdForm.vue?vue&type=script&lang=js"
export * from "./AdForm.vue?vue&type=script&lang=js"
script.render = render

export default script